import { defineMessages } from 'react-intl';

export default defineMessages({
    closeTooltipLink: {
        id: 'wmic.policy.component.clickable-icon-tooltip.Close tooltip',
        defaultMessage: 'Close tooltip'
    },
});
